import {origin} from 'config/app';

export const LIVE = `https://www.${origin}`;
export const LIVE_CF = `https://app.${origin}`;

export const SANDBOX = `https://sandbox.${origin}`;
export const SANDBOX_CF = `https://app-sandbox.${origin}`;
